<template>
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9165 5.50666H4.58348C2.05348 5.50666 0 7.55925 0 10.0882V17.4185C0 19.9474 2.05348 22 4.58348 22H11.917C14.447 22 16.5004 19.9474 16.5004 17.4185V10.0882C16.5004 7.55925 14.447 5.50666 11.917 5.50666H11.9165ZM13.75 17.4185C13.75 18.4265 12.925 19.2512 11.9165 19.2512H4.58348C3.575 19.2512 2.75 18.4265 2.75 17.4185V10.0882H13.75V17.4185ZM22 5.04881V11.7834C22 13.0114 21.551 14.1934 20.735 15.1185C20.46 15.4299 20.084 15.5858 19.699 15.5858C19.378 15.5858 19.048 15.4759 18.7915 15.2375C18.223 14.7337 18.168 13.8631 18.6725 13.2948C19.039 12.8735 19.241 12.3418 19.241 11.783V5.04881C19.241 3.78435 18.2145 2.75827 16.9495 2.75827H10.212C9.65293 2.75827 9.11195 2.9597 8.69945 3.3265C8.13098 3.83031 7.26043 3.77533 6.75598 3.20753C6.25195 2.6393 6.30695 1.76912 6.875 1.26489C7.79152 0.448831 8.98348 0 10.2115 0H16.949C19.7265 0 21.9905 2.26305 21.9905 5.03936L21.9996 5.04838L22 5.04881Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconBanners'
}
</script>
